
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Constants.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export class ProductPlanTagConstants {
	static prefixForProductTags: ProductPlanTagConstantsType = 'ProductPlan.';
	static microsoft365: ProductPlanTagConstantsType = 'Microsoft365';
	static web: ProductPlanTagConstantsType = 'Web';
	static webshop: ProductPlanTagConstantsType = 'Webshop';
	static cookie: ProductPlanTagConstantsType = 'Cookie';
	static seo: ProductPlanTagConstantsType = 'Seo';
	static ads: ProductPlanTagConstantsType = 'Ads';
	static socialMedia: ProductPlanTagConstantsType = 'SocialMedia';
	static goCommerce: ProductPlanTagConstantsType = 'GoCommerce';
	static logo: ProductPlanTagConstantsType = 'Logo';
	static video: ProductPlanTagConstantsType = 'Video';
	static textProduction: ProductPlanTagConstantsType = 'Tekstforfatning';
	static offerCalculator: ProductPlanTagConstantsType = 'Tilbudsberegner';
	static microsoft365Backup: ProductPlanTagConstantsType = 'Microsoft365Backup';
	static mailLight: ProductPlanTagConstantsType = 'MailLight';
	static domainDk: ProductPlanTagConstantsType = 'DomæneDk';
	static domainForeign: ProductPlanTagConstantsType = 'DomæneUdenlandsk';
	static aiSearch: ProductPlanTagConstantsType = 'AiSearch';
	static aiAssistant: ProductPlanTagConstantsType = 'AiAssistant';
	static standoutSyncAddOnOrderApproval: ProductPlanTagConstantsType = 'StandoutSync.AddOnOrderApproval';
	static standoutSyncActive: ProductPlanTagConstantsType = 'StandoutSync.Active';
	static noAutoStart: ProductPlanTagConstantsType = 'NoAutoStart';

	static values = ['ProductPlan.', 'Microsoft365', 'Web', 'Webshop', 'Cookie', 'Seo', 'Ads', 'SocialMedia', 'GoCommerce', 'Logo', 'Video', 'Tekstforfatning', 'Tilbudsberegner', 'Microsoft365Backup', 'MailLight', 'DomæneDk', 'DomæneUdenlandsk', 'AiSearch', 'AiAssistant', 'StandoutSync.AddOnOrderApproval', 'StandoutSync.Active', 'NoAutoStart'];
}
export type ProductPlanTagConstantsType = 'ProductPlan.' | 'Microsoft365' | 'Web' | 'Webshop' | 'Cookie' | 'Seo' | 'Ads' | 'SocialMedia' | 'GoCommerce' | 'Logo' | 'Video' | 'Tekstforfatning' | 'Tilbudsberegner' | 'Microsoft365Backup' | 'MailLight' | 'DomæneDk' | 'DomæneUdenlandsk' | 'AiSearch' | 'AiAssistant' | 'StandoutSync.AddOnOrderApproval' | 'StandoutSync.Active' | 'NoAutoStart';
export class ProductPlanAdsTagConstants {
	static prefixForAdsProductTags: ProductPlanAdsTagConstantsType = 'Ads.';
	static boost: ProductPlanAdsTagConstantsType = 'Boost';
	static reTry: ProductPlanAdsTagConstantsType = 'ReTry';
	static try: ProductPlanAdsTagConstantsType = 'Try';

	static values = ['Ads.', 'Boost', 'ReTry', 'Try'];
}
export type ProductPlanAdsTagConstantsType = 'Ads.' | 'Boost' | 'ReTry' | 'Try';
export class ProductPlanMarketingTagConstants {
	static prefixForMarketingProductTags: ProductPlanMarketingTagConstantsType = 'Marketing.';
	static start: ProductPlanMarketingTagConstantsType = 'Start';
	static growth: ProductPlanMarketingTagConstantsType = 'Vækst';

	static values = ['Marketing.', 'Start', 'Vækst'];
}
export type ProductPlanMarketingTagConstantsType = 'Marketing.' | 'Start' | 'Vækst';

